// Addtional label for variant width option on pdp

(function () {
  const changeAddtionalWidthOptionLabel = () => {
    const additionalLable = document.querySelector(".addtional-width-label");
    const selectedInput = document.querySelector(
      "[data-additional-label]:checked",
    );
    if (additionalLable) {
      additionalLable.textContent = selectedInput.dataset.additionalLabel;
    }
  };
  document.querySelectorAll("[data-additional-label]").forEach((input) => {
    input.addEventListener("change", () => {
      changeAddtionalWidthOptionLabel();
    });
  });
  document.addEventListener("DOMContentLoaded", () => {
    changeAddtionalWidthOptionLabel();
  });
})();

if (!customElements.get("location-availability-badge")) {
  const REFRESH_INTERVAL = 60 * 1000;
  const WEEKDAY_INDEX = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
  };
  const DAY_ALIASES = {
    su: 0,
    sun: 0,
    sunday: 0,
    mo: 1,
    mon: 1,
    monday: 1,
    tu: 2,
    tue: 2,
    tuesday: 2,
    we: 3,
    wed: 3,
    wednesday: 3,
    th: 4,
    thu: 4,
    thursday: 4,
    fr: 5,
    fri: 5,
    friday: 5,
    sa: 6,
    sat: 6,
    saturday: 6,
  };

  class LocationAvailabilityBadge extends HTMLElement {
    connectedCallback() {
      this.openLabel = this.dataset.openLabel;
      this.closedLabel = this.dataset.closedLabel;
      this.opensLabel = this.dataset.opensLabel;
      this.timezone = this.dataset.timezone || "Europe/Zurich";
      this.schedule = this.parseSchedule(this.dataset.schedule);

      this.updateAvailability();
      this.startRefreshLoop();
    }

    disconnectedCallback() {
      this.stopRefreshLoop();
    }

    startRefreshLoop() {
      this.stopRefreshLoop();
      this.refreshTimer = window.setInterval(() => {
        this.updateAvailability();
      }, REFRESH_INTERVAL);
    }

    stopRefreshLoop() {
      if (!this.refreshTimer) return;

      window.clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }

    parseSchedule(rawSchedule) {
      const normalizedSchedule = this.createDefaultSchedule();

      if (!rawSchedule) return normalizedSchedule;

      try {
        const parsedSchedule = JSON.parse(rawSchedule);
        for (const [key, value] of Object.entries(parsedSchedule)) {
          this.applyScheduleEntry(normalizedSchedule, key, value);
        }
        return normalizedSchedule;
      } catch (error) {
        return normalizedSchedule;
      }
    }

    createDefaultSchedule() {
      return Array.from({ length: 7 }, (_, dayIndex) => ({
        dayIndex,
        intervales: [],
      }));
    }

    applyScheduleEntry(schedule, rawIndex, rawEntry) {
      const dayIndex = parseInt(rawIndex);
      const hoursString =
        rawEntry && typeof rawEntry === "object" ? rawEntry.hours : rawEntry;
      schedule[dayIndex] = {
        dayIndex,
        intervales: hoursString
          ? hoursString.split(",").map((inter) => inter.trim())
          : [],
      };
    }

    isCurrentTimeInRange(timeRangeStr, currentTotalMinutes) {
      const [startPart, endPart] = timeRangeStr
        .split("-")
        .map((str) => str.trim());

      const [startHours, startMinutes] = startPart.split(":").map(Number);
      const [endHours, endMinutes] = endPart.split(":").map(Number);

      const startTotalMinutes = startHours * 60 + startMinutes;
      const endTotalMinutes = endHours * 60 + endMinutes;

      return (
        currentTotalMinutes >= startTotalMinutes &&
        currentTotalMinutes < endTotalMinutes
      );
    }

    getCurrentLocalTime() {
      const formatter = new Intl.DateTimeFormat("en-GB", {
        timeZone: this.timezone,
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      const parts = formatter.formatToParts(new Date());
      const weekday = parts.find((part) => part.type === "weekday")?.value;
      const hour = Number(parts.find((part) => part.type === "hour")?.value);
      const minute = Number(
        parts.find((part) => part.type === "minute")?.value,
      );

      const dayIndex = WEEKDAY_INDEX[weekday];

      if (
        dayIndex === undefined ||
        Number.isNaN(hour) ||
        Number.isNaN(minute)
      ) {
        return null;
      }

      return {
        dayIndex,
        minutes: hour * 60 + minute,
      };
    }

    isOpen(daySchedule, currentTotalMinutes) {
      if (!daySchedule) {
        return false;
      }
      let isopen = false;
      daySchedule.intervales.forEach((interval) => {
        if (!isopen) isopen = this.isCurrentTimeInRange(interval, currentTotalMinutes);
      });

      return isopen;
    }

    getNextOpeningTime(currentTime) {
      if (!currentTime || !Array.isArray(this.schedule)) return null;

      for (let offset = 0; offset < 7; offset++) {
        const targetDayIndex = (currentTime.dayIndex + offset) % 7;
        const daySchedule = this.schedule[targetDayIndex];

        if (!daySchedule || !daySchedule.intervales.length) continue;

        for (const interval of daySchedule.intervales) {
          const parts = interval.split(" - ");
          if (parts.length < 2) continue;
          const startTime = parts[0].trim();
          const [startHours, startMinutes] = startTime.split(":").map(Number);
          const startTotalMinutes = startHours * 60 + startMinutes;

          if (offset === 0 && startTotalMinutes <= currentTime.minutes) continue;

          return { dayIndex: targetDayIndex, time: startTime };
        }
      }

      return null;
    }

    getDayName(dayIndex) {
      // Jan 5 2025 is a Sunday (dayIndex 0)
      const date = new Date(2025, 0, 5 + dayIndex);
      const lang = document.documentElement.lang || navigator.language || "en";
      return new Intl.DateTimeFormat(lang, { weekday: "short" }).format(date);
    }

    updateAvailability() {
      const currentTime = this.getCurrentLocalTime();

      const todaySchedule =
        currentTime && Array.isArray(this.schedule)
          ? this.schedule[currentTime.dayIndex]
          : null;

      const isOpen = this.isOpen(todaySchedule, currentTime?.minutes);

      if (isOpen) {
        this.dataset.state = "open";
        this.textContent = this.openLabel;
      } else {
        this.dataset.state = "closed";
        const next = this.getNextOpeningTime(currentTime);
        if (next && currentTime) {
          this.textContent = `${this.opensLabel} ${this.getDayName(next.dayIndex)} ${next.time}`;
        } else {
          this.textContent = this.closedLabel;
        }
      }
    }
  }

  customElements.define(
    "location-availability-badge",
    LocationAvailabilityBadge,
  );
}
